import * as zod from 'zod';

export const signInFormSchema = zod.object({
  email: zod
    .string()
    .min(1, { message: 'Please enter your username' }),
  password: zod.string().min(1, { message: 'Please enter your password' }),
});

export type SignInFormValuesType = zod.infer<typeof signInFormSchema>;
